import {useSelector} from "react-redux";
import {studiesUngrouped} from "../../store/reducers/documents";
import {AgyleTable, createAgyleTableColumn} from "../../components/table/AgyleTable";
import {useEffect, useState} from "react";

function StudiesList() {

    const studiesObject = useSelector(studiesUngrouped);
    const [columns, setColumns] = useState([]);

    const initColumns = () => {
        const columnsArr = [
            createAgyleTableColumn("id", "Images", 1, "documents.length", "string", "", "medium", "center", "none"),
            createAgyleTableColumn("name", "Date", 2, "startDate", "date", "", "medium", "center", "none"),
            createAgyleTableColumn("__typeString", "Type", 3, "__typeString", "string", "", "medium", "start", false, true),
            createAgyleTableColumn("__operator", "Operator", 4, "__operator", "string", "", "medium", "start", false,true),
            createAgyleTableColumn("__location", "Location", 5, "__location", "string", "", "medium", "start", false,true),
        ];
        setColumns(columnsArr);
    };

    useEffect(()=>{
        initColumns();
    },[])


    return (
        <AgyleTable
            columns={columns}
            data={studiesObject}
        />)
}
export default StudiesList